<template>
    <div class="npa">
        <div class="cen">
            <div class="mr"></div>
           
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FВыписка%20из%20единого%20реестра%20лицензий.pdf&name=Выписка%20из%20единого%20реестра%20лицензий.pdf" target="_blank" rel="noopener">
                <h6>
                    Выписка из единого реестра лицензий
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FО%20возможности%20получения%20бесплатной%20медицинской%20помощи.docx&name=О%20возможности%20получения%20бесплатной%20медицинской%20помощи.docx&nosw=1" target="_blank" rel="noopener">
                <h6>
                    О возможности получения бесплатной медицинской помощи
                </h6>
            </a>
            <a href=" https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FО%20порядке%20и%20условиях%20предоставления%20медицинской%20помощи%20бесплатно%20на%20сайт.doc&name=О%20порядке%20и%20условиях%20предоставления%20медицинской%20помощи%20бесплатно%20на%20сайт.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    О порядке и условиях предоставления медицинской помощи бесплатно
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПрава%20и%20обязанности%20граждан%20в%20сфере%20охраны%20здоровья.doc&name=Права%20и%20обязанности%20граждан%20в%20сфере%20охраны%20здоровья.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Права и обязанности граждан в сфере охраны здоровья
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПорядки%20оказания%20медицинской%20помощи.docx&name=Порядки%20оказания%20медицинской%20помощи.docx&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Порядки оказания медицинской помощи
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FОбразец%20договора%20на%20оказание%20платных%20медицинских%20услуг%20ДентаКор%20Плюс%20с%2001.09.2023.doc&name=Образец%20договора%20на%20оказание%20платных%20медицинских%20услуг%20ДентаКор%20Плюс%20с%2001.09.2023.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Образец договора на оказание платных медицинских услуг ДентаКор Плюс
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПриложение%20к%20договору%20Перечень%20медицинских%20услуг%20ДентаКор%20Плюс.doc&name=Приложение%20к%20договору%20Перечень%20медицинских%20услуг%20ДентаКор%20Плюс.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Приложение к договору Перечень медицинских услуг ДентаКор Плюс
                </h6>
            </a>
            
            

            <router-link class="lin" to="/prav">
                <p> Дополнительная информация расположена на странице "Правовая информация" > Перейти</p>
            </router-link>
            
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

.npa {
    background-color: #f5ee92;
    height: 110vh;
}

.cen {
    width: 80vw;
    margin: 10vh auto;
}

.mr {
    height: 20vh;
}

h6 {
    font-size: 1.7vw;
    cursor: pointer;
    transition: all 0.4s ease;
    margin-bottom: 5vh;
}

h6:hover {
    color: #bb8745;
    transition: all 0.4s ease;
}

@media (max-width: 790px) {

    .npa {
        height: 110vh;
    }

    .cen {
        width: 90vw;
    }

    .mr {
        height: 10vh;
    }

    h6 {
        font-size: 20px;
    }

}

</style>